import { CurrentUserService } from '../../auth';
import { NavItem, Person, User } from '../../../common/models';

export class NavManager {
  constructor(private appName: string, private shortEnv: string, private currentUserService: CurrentUserService) { }

  async deriveTabs(contextUser: User | User[] = []): Promise<NavItem[]> {
    const contextUsers = contextUser && Array.isArray(contextUser) ?
      contextUser :
      (contextUser ? [contextUser] : []);
    const person = contextUsers.length && contextUsers[0].isOfType && (contextUsers[0] as any).isOfType('Person') ?
      contextUsers[0] as Person :
      undefined;

    const programCodes: string[] = contextUsers
      .filter(program => program.isOfType && program.isOfType('Program') && program.code)
      .map(program => program.code as string);

    const {
      GradHub = [],
      PRM = [],
      SPA = [],
      eDocs = [],
      Appian = [],
    } = await this.currentUserService.findAllPermissions();

    const tabs: NavItem[] = [];
    let url = '';
    const prefix = this.shortEnv.includes('prod') ? '' : 'test.';

    if (GradHub.length > 0) {
      url = `https://${prefix}gradhub.ucdavis.edu`;

      if (this.appName !== 'GradHub') {
        if (person && person.studentId) {
          url += `/student/${person.studentId}`;
        } else if (programCodes.length) {
          url += `/student/search?majorCodes=${programCodes.join('&majorCodes=')}`;
        }
      }

      tabs.push({
        route: url,
        text: 'GradHub',
        active: this.appName === 'GradHub',
        tooltip: 'Graduate Student Portal'
      });
    }
    
    if (Appian.length > 0) {
      url = prefix === '' ? `https://gradsphere.ucdavis.edu/` : 'https://ucdavistest.appiancloud.com/suite/';

      tabs.push({
        route: url,
        text: 'GradSphere',
        active: this.appName === 'GradSphere',
        tooltip: 'GradSphere'
      });
    }

    if (eDocs.length > 0) {
      url = `https://edocs.${prefix}gradhub.ucdavis.edu`;

      if (this.appName !== 'eDocs') {
        if (person) {
          url += `/subject/${person.id}`;
        } else if (programCodes.length) {
          url += `/program/${contextUsers[0].id}`;
        }
      }

      tabs.push({
        route: url,
        text: 'eDocs',
        active: this.appName === 'eDocs',
        tooltip: 'GradHub document management'
      });
    }

    if (SPA.length > 0) {
      url = `https://spa.${prefix}gradhub.ucdavis.edu`;

      if (this.appName !== 'SPA') {
        if (person && person.studentId) {
          url += `/assessments/student/${person.studentId}`;
        } else if (programCodes.length) {
          url += `/assessments?programCodes=${programCodes.join('&programCodes=')}`;
        }
      }

      tabs.push({
        route: url,
        text: 'SPA',
        active: this.appName === 'SPA',
        tooltip: 'Student Progress Assessment'
      });
    }

    if (PRM.length > 0) {
      url = `https://prm.${prefix}gs.ucdavis.edu`;

      if (this.appName !== 'PRM') {
        if (person) {
          url += `/person/${person.loginId || person.id}`;
        } else if (programCodes.length) {
          url += `/user-role/app/GradHub/by-group/${programCodes[0]}`;
        }
      }

      tabs.push({
        route: url,
        text: 'PRM',
        active: this.appName === 'PRM',
        tooltip: 'People & Roles Manager'
      });
    }

    if (GradHub.length > 0) {
      url = `https://${prefix}gard.ucdavis.edu`;

      if (this.appName !== 'GARD') {
        if (programCodes.length) {
          url += `/?major_code=${programCodes[0]}`;
        }
      }

      tabs.push({ route: url, text: 'GARD', tooltip: 'Graduate Admission Review & Decision' });
    }

    url = `https://stats.${prefix}gradhub.ucdavis.edu`;

    if (this.appName !== 'Stats') {
      if (programCodes.length) {
        url += `/summary?program=${programCodes[0]}`;
      }
    }

    tabs.push({
      route: url,
      text: 'Stats',
      active: this.appName === 'Stats',
      tooltip: 'Graduate Program Statistics'
    });

    url = `https://programs.${prefix}gs.ucdavis.edu`;

    if (this.appName !== 'Programs Manager') {
      if (programCodes.length) {
        url += `/program/${programCodes[0]}/people`;
      }
    }

    tabs.push({
      route: url,
      text: 'Programs',
      active: this.appName === 'Programs Manager',
      tooltip: 'Graduate Programs'
    });

    return tabs;
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/client/react/layout/NavManager.ts